import Phaser from "phaser";
import type { SkeletonEnemy } from "./SkeletonEnemy";

export class EnemySquad {
  private readonly members: SkeletonEnemy[] = [];

  add(enemy: SkeletonEnemy): void {
    this.members.push(enemy);
  }

  alive(): SkeletonEnemy[] {
    return this.members.filter((member) => member.isAlive());
  }

  separation(enemy: SkeletonEnemy, radius = 92): Phaser.Math.Vector2 {
    const force = new Phaser.Math.Vector2();
    let count = 0;
    for (const other of this.alive()) {
      if (other === enemy) continue;
      const dx = enemy.x - other.x;
      const dy = enemy.y - other.y;
      const distanceSq = dx * dx + dy * dy;
      if (distanceSq <= 0 || distanceSq > radius * radius) continue;
      const distance = Math.sqrt(distanceSq);
      force.add(new Phaser.Math.Vector2(dx / distance, dy / distance).scale(1 - distance / radius));
      count += 1;
    }
    if (count > 0) force.scale(1 / count);
    return force;
  }

  countNear(x: number, y: number, radius: number): number {
    const radiusSq = radius * radius;
    return this.alive().filter((member) => {
      const dx = member.x - x;
      const dy = member.y - y;
      return dx * dx + dy * dy <= radiusSq;
    }).length;
  }
}
